import React, { Component } from 'react';

class QualificationItemComponent extends Component {
    render() {
        return (
            <li className="qualification">
                <span>{this.props.date}</span>
                <ul className="qualification-details">
                    <li className="qualification-name">{this.props.name}</li>
                    <li className="qualification-issuer">{this.props.issuer}</li>
                    <li className="qualification-place">{this.props.place}</li>
                </ul>
            </li>
        );
    }
}

export default QualificationItemComponent;



// WEBPACK FOOTER //
// ./src/components/qualification/qualification.item.component.jsx